// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KyVI","question":"styles_question__2Hk0h","description":"styles_description__10PM4"};